import React, { useCallback } from 'react';
import TourOverlay from './tour/TourOverlay';
import { DEMO_TOUR_STEPS, markDemoTourSeen } from '../utils/demoTour';

// Spacer po całej aplikacji dla organizacji demo (D.10). Otwierany raz przy pierwszym
// wejściu (App.js) i ponownie z bannera; sama mechanika podświetlania — tour/TourOverlay.js.
export default function DemoTour({ open, onClose, userId, storage }) {
  const close = useCallback(() => {
    // „Widziane" zapisujemy przy KAŻDYM zamknięciu (także pominięciu) — inaczej
    // przewodnik wracałby przy każdym wejściu do kogoś, kto go świadomie zamknął.
    markDemoTourSeen(storage || (typeof window !== 'undefined' ? window.localStorage : null), userId);
    onClose?.();
  }, [onClose, storage, userId]);

  return <TourOverlay open={open} steps={DEMO_TOUR_STEPS} onClose={close} testId="demo-tour" />;
}
